export const authenticationErrors: Record<string, string> = {
  'Invalid username/password.': 'errors.invalidUsernamePassword',
  SESSION_ALREADY_USED: 'errors.sessionAlreadyUsed',
  'Unauthorized role': 'auth.unauthorized',
  USER_DISABLED: 'auth.userDisabled',
};
